import {
  REQUEST_SOUNDS_FULLS, RECEIVE_SOUNDS_FULLS, RECEIVE_SOUNDS_FULL,
} from '../actions/sounds-full';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_SOUNDS_FULLS:
      return { ...state, loading: true };
    case RECEIVE_SOUNDS_FULLS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_SOUNDS_FULL:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
